'use client'

import { ErrorContent } from '@marketplace-web/error-display/error-display-feature'

// TODO: localise this
const title = 'Oops! Something went wrong.'
const body =
  "We apologize for the inconvenience, but it appears that we're experiencing some technical difficulties at the moment. Our team has already been alerted and is working to fix the issue. Thank you for your patience!"
const action = 'Reload'

type Props = {
  reset: () => void
}

const ErrorPage = ({ reset }: Props) => (
  <main className="container">
    <ErrorContent action={action} body={body} title={title} onActionClick={reset} />
  </main>
)

export default ErrorPage
